import Picture from "../../../components/Picture";

export default function AccessBackground() {
    return (
        <div className="absolute inset-0 z-0">
            <Picture
                slug="private_access_hero"
                alt=""
                priority
                sizes="100vw"
                className="absolute inset-0 h-full w-full object-cover animate-ken-burns"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0C]/75 via-[#0B0B0C]/82 to-[#0B0B0C]" />
        </div>
    );
}
